/**
 * Vendor disbursements — step 14. Mirrors packages/shared/src/schemas/disbursements.ts
 * (the owner side), adapted for the differences CLAUDE.md's "Vendor
 * disbursements" section confirms: no period, no co-ownership split, the
 * vendor receives the full WorkOrder.cost (no fee line), and staff select a
 * subset of a vendor's eligible completed work orders per approval rather
 * than paying everything eligible at once.
 */
import { z } from 'zod';
import { VENDOR_DISBURSEMENT_STATUSES } from '../enums.js';
import { dateOnlySchema, optionalText, text, uuidSchema } from './common.js';
export const vendorDisbursementStatusSchema = z.enum(VENDOR_DISBURSEMENT_STATUSES);
export const vendorDisbursementListQuerySchema = z.object({
    vendorId: uuidSchema.optional(),
    status: vendorDisbursementStatusSchema.optional(),
});
export const eligibleWorkOrdersQuerySchema = z.object({
    vendorId: uuidSchema,
});
/**
 * One vendor, an explicit, non-empty set of that vendor's own eligible
 * completed work orders — the "selectable subset" decision. No period: the
 * idempotency backstop is VendorDisbursementLine.workOrderId being globally
 * unique, not an (vendorId, period) key — see that model's doc comment in
 * schema.prisma.
 */
export const approveVendorDisbursementSchema = z.object({
    vendorId: uuidSchema,
    workOrderIds: z.array(uuidSchema).min(1, 'Select at least one work order to pay out.'),
});
/**
 * Same shape as settleOwnerDisbursementExternallySchema — a staff-recorded
 * check/wire reference, no Stripe call. See VendorDisbursementStatus.
 */
export const settleVendorDisbursementExternallySchema = z.object({
    referenceNumber: text(255),
    settledOn: dateOnlySchema,
    note: optionalText(2000),
});
//# sourceMappingURL=vendor-disbursements.js.map